export default "__VITE_ASSET__DUec9Cfj__"